import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, LinkButton, ReactLinkButton } from './styles';
import useIsScrolled from '../../../../../hooks/useIsScrolled';
import { LightIcon } from '../LightIcon/LightIcon';

const getComponent = (type) => {
    switch (type) {
        case 'tagA':
            return LinkButton;
        case 'button':
            return CommonButton;
        default:
            return ReactLinkButton;
    }
};

const DiskButtonPure = ({ iconName = 'cross', iconColor = 'darkGray', size = 'tight', ...props }) => {
    const isScroll = useIsScrolled();
    const Wrapper = getComponent(props.type);
    const isTagA = props.type === 'tagA';
    const raised = props.raised === undefined ? isScroll : props.raised;
    return (
        <Wrapper
            type={props.type === 'button' ? props.type : null}
            variant={props.variant}
            size={size}
            raised={isTagA ? raised : raised.toString()}
            to={props.to}
            href={props.href}
            onClick={props.onClick}
            data-testid={props.dataTestId}
            $marginRight={props.marginRight}
            id={props.id}
            useThemeColor={props.useThemeColor}
        >
            <LightIcon name={iconName} color={iconColor} size={size === 'small' ? '16px' : '24px'} useThemeColor={props.useThemeColor} />
        </Wrapper>
    );
};
export const LightDiskButton = React.memo(DiskButtonPure);

LightDiskButton.propTypes = {
    // type: <Link>(default) or <a> (type === 'tagA') or <button> (type === 'button')
    type: PropTypes.oneOf(['tagA', 'button']),
    size: PropTypes.oneOf(['small', 'tight', 'fit']),
    raised: PropTypes.bool,
    to: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    dataTestId: PropTypes.string,
    useThemeColor: PropTypes.bool,
};
